import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import MainRoutes from "./routes";
import "./App.css";
import { captureUtmsFromUrl } from "./utils/utmStorage";

export function useUTMCapture() {
  useEffect(() => {
    captureUtmsFromUrl();
  }, []); // runs once on mount
}

function App() {
  useUTMCapture();
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <BrowserRouter>
      <MainRoutes />
    </BrowserRouter>
  );
}

export default App;
